import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export default (theme: Theme) =>
  StyleSheet.create({
    // Header personnalisé
    customHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      backgroundColor: theme.colors.white,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    backButton: {
      padding: theme.spacing.sm,
      marginRight: theme.spacing.sm,
    },
    headerContent: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerLeft: {
      position: 'relative',
      marginRight: theme.spacing.md,
    },
    
    // Avatars de groupe superposés
    groupAvatars: {
      position: 'relative',
      width: 50,
      height: 40,
    },
    groupAvatar: {
      width: 32,
      height: 32,
      borderRadius: 16,
      position: 'absolute',
      borderWidth: 2,
      borderColor: theme.colors.white,
    },
    groupAvatar1: {
      top: 0,
      left: 0,
      zIndex: 2,
    },
    groupAvatar2: {
      top: 8,
      left: 18,
      zIndex: 1,
    },
    
    headerInfo: {
      flex: 1,
    },
    headerName: {
      color: theme.colors.secondary,
      marginBottom: 2,
    },
    headerStatus: {
      color: theme.colors.greyBlue,
    },
    headerActions: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerAction: {
      padding: theme.spacing.sm,
      marginLeft: theme.spacing.xs,
    },

    // Messages
    messagesList: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    messagesContent: {
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
    },
    messageContainer: {
      marginBottom: theme.spacing.md,
    },
    messageFooter: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: theme.spacing.xs,
    },
    receivedMessageContainer: {
      alignItems: 'flex-start',
      flexDirection: 'row',
      maxWidth: '100%'
    },
    sentMessageWrapper: {
      alignItems: 'flex-end',
    },
    pinButton: {
      marginLeft: theme.spacing.xs,
      padding: theme.spacing.xs,
    },
    receivedMessageWrapper: {
      alignItems: 'flex-start',
    },
    sentMessage: {
      backgroundColor: theme.colors.primary,
      borderRadius: 18,
      borderBottomRightRadius: 4,
      overflow: 'hidden',
      flex: 1
    },
    receivedMessage: {
      backgroundColor: theme.colors.white,
      borderRadius: 18,
      borderBottomLeftRadius: 4,
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      borderWidth: 1,
      borderColor: theme.colors.greyBlue,
      flex: 1
    },
    
    // Nom de l'expéditeur pour les groupes
    senderName: {
      color: '#8B5CF6', // Violet pour le nom
      fontSize: theme.fontSize.small,
      marginBottom: theme.spacing.xs,
    },
    
    sentMessageText: {
      color: theme.colors.white,
      fontSize: theme.fontSize.medium,
      padding: theme.spacing.sm,
    },
    receivedMessageText: {
      color: theme.colors.secondary,
      fontSize: theme.fontSize.medium,
      marginBottom: theme.spacing.xs,
    },
    sentMessageTime: {
      color: theme.colors.greyBlue,
      fontSize: theme.fontSize.extraSmall,
      marginTop: theme.spacing.xs,
      alignSelf: 'flex-end',
    },
    receivedMessageTime: {
      color: theme.colors.greyBlue,
      fontSize: theme.fontSize.extraSmall,
      marginTop: theme.spacing.xs,
      alignSelf: 'flex-start',
    },
    messageAvatar: {
      width: 20,
      height: 20,
      borderRadius: 10,
      marginRight: theme.spacing.sm,
    },
    messageImage: {
      width: 150,
      height: 150,
      borderTopLeftRadius: 18,
      borderTopRightRadius: 18
    },

    // Input
    inputContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.md,
      backgroundColor: theme.colors.white,
    },
    inputWrapper: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-end',
      backgroundColor: theme.colors.grey,
      borderRadius: 25,
      paddingHorizontal: theme.spacing.xs,
      paddingVertical: theme.spacing.xs,
      marginRight: theme.spacing.sm,
      minHeight: 40,
    },
    textInput: {
      flex: 1,
      fontSize: theme.fontSize.medium,
      lineHeight: theme.fontSize.medium,
      paddingVertical: (40 - theme.fontSize.medium)/3,
      color: theme.colors.secondary,
      maxHeight: 100,
      paddingHorizontal: theme.spacing.md,
      marginRight: theme.spacing.sm,
      
    },
    sendButton: {
      width: 40,
      height: 40,
      borderRadius: 20,
      backgroundColor: theme.colors.primary,
      justifyContent: 'center',
      alignItems: 'center',
    },
    imageButton: {
      width: 50,
      height: 50,
      borderRadius: 25,
      backgroundColor: theme.colors.lightGrey,
      justifyContent: 'center',
      alignItems: 'center',
    },
    removeImageIcon: {
      position: 'absolute',
      top: -theme.spacing.xs,
      right: -theme.spacing.xs,
      borderRadius: 15,
      padding: theme.spacing.xxs,
      zIndex: 1,
      backgroundColor: theme.colors.error
    },
    actionsContainer: {
      alignSelf: 'flex-start',
    },
  }) 